export const ProjectConstants = {
    maxFileSize: 700000,
    isSizeChecktrue: "true",
    isSizeCheckfalse: "false",
    responseGriExist: "Grievance Exist",
    responseStatusSuccess: "Success",
    responseStatusFailure: "Failure",

    dialogCloseYes: "Yes",
    noMsg:"No",
    noAbleToDownloadErCode: `5005`,

    otpValidityExpired: "Validity Expired !!!",
    otpInvalidStatus: "Invalid",
    otpInvalidStatusMsg: "Invalid OTP, Please try again",
    otpInvalidStatusMrMsg: "अवैध OTP, कृपया पुन्हा प्रयत्न करा",
    otpValidityExpiredMr:"वैधता कालबाह्य !!!",

    grievanceBackendTimeoutMsg: "Grievance Backend Timeout",
    lotteryBackendTimeoutMsg: "Lottery Backend Timeout",
    registrationExceptionCode:5008,
    registrationExceptionEnMsg:"Please complete your registration.",
    registrationExceptionMrMsg:"कृपया तुमची नोंदणी पूर्ण करा.",
    nogtypeInSelectedBoardEn:"No grievance types found against selected board",
    nogtypeInSelectedBoardMr: "निवडलेल्या मंडळाविरुद्ध तक्रारीचे प्रकार आढळले नाहीत",

    networkErrorEnMsg:"There was network related or instance related error understanding the request. Please try doing it again.",
    networkErrorMrMsg:"विनंती समजून घेण्यात नेटवर्कशी संबंधित किंवा उदाहरण संबंधित त्रुटी आली. कृपया ते पुन्हा करण्याचा प्रयत्न करा.",

    tokenExpireEnMsg:"Security Token is expired, please relogin with DigiLocker.",
    tokenExpireMrMsg:"सुरक्षा टोकन कालबाह्य झाले आहे, कृपया DigiLocker सह पुन्हा लॉगिन करा.",

    uploadFromEn :"Upload from",
    uploadFromMr:"अपलोड करा",

    galleryMr : "गॅलरी",
    galleryEn: "Gallery",
    cameraEn: "Camera",
    cameraMr: "कॅमेरा",

    fileDownloadSuccessEn:"File Downloaded successfully!!!..",
    fileDownloadSuccessMr:"फाइल यशस्वीरित्या डाउनलोड झाली !!!..",
    fileDownloadErrorEn:"Not able to download file",
    fileDownloadErrorMr:"फाइल डाउनलोड करण्यास सक्षम नाही",

    replySuccessEn:"Sent reply successfully",
    replySuccessMr:"यशस्वीरित्या उत्तर पाठवले",

    resendOtpSuccessEn:"OTP resend successfully!!!..",
    resendOtpSuccessMr:"ओटीपी यशस्वीरित्या पुन्हा पाठवला!!!..",


    docSplit:"/"
}